<template>
  <!-- A video with a poster (your own, or a Pexels pick). Never plays with
       sound by itself; "autoplay" plays it muted and looping, and not at all
       with reduced motion. -->
  <SectionBand :heading="section.heading || section.title" :variant="variant" :background="section.background" :width="section.layout === 'full' ? 'wide' : 'normal'" label="Video">
    <Media :media="{type: 'video', video: video, caption: section.caption}" :caption="true" :autoplay="section.autoplay === true" ratio="16 / 9" />
  </SectionBand>
</template>

<script setup>
import {computed} from "vue";
import SectionBand from "../shared/SectionBand.vue";
import Media from "../shared/Media.vue";
import {mediaOf} from "@/utils/blocks.js";

const props = defineProps({section: {type: Object, required: true}, variant: {type: [Number, String], default: 1}});
const video = computed(() => {
  const v = props.section.video;
  const base = v && typeof v === "object" ? (v.video && typeof v.video === "object" ? v.video : v) : {link: typeof v === "string" ? v : ""};
  const poster = props.section.poster ? mediaOf(props.section.poster).src : "";
  return {...base, poster: poster || base.poster || ""};
});
</script>
